<template>
  <div class="card_box">
    <Card>
      <div slot="title" class="titlebox">
        <span class="title">{{ $t("label.AcceptanceSearch.AcceptanceApplication")}}</span>
        <Icon type="ios-create-outline" class="applyicon" />
      </div>
      <!-- 主表内容 -->
      <Form ref="formdata" :model="formdata" :rules="rules">
        <table class="form-table form-table-print">
          <!-- 基本信息 -->
          <tr>
            <th class="requiredIitm">{{ $t("label.Acceptance.AcceptanceNo") }}</th>
            <td>
              <Form-item prop="acceptanceId">
                <Input type="text" v-model="formdata.acceptanceId" readonly disabled />
              </Form-item>
            </td>
            <th class="requiredIitm">{{ $t("label.Acceptance.AcceptanceID") }}</th>
            <td>
              <Form-item prop="applicantUserId">
                <Input type="text" v-model="formdata.applicantUserId" disabled />
              </Form-item>
            </td>
            <th class="requiredIitm">{{ $t("label.AcceptanceSearch.Acceptance") }}</th>
            <td>
              <Form-item prop="applicantUserName">
                <Input type="text" v-model="formdata.applicantUserName" disabled />
              </Form-item>
            </td>
          </tr>

          <tr>
            <th class="requiredIitm">{{ $t("label.Acceptance.SupplierName") }}</th>
            <td>
              <Form-item prop="vendorName">
                <Input type="text" v-model="formdata.vendorName" disabled />
              </Form-item>
            </td>

            <th class="requiredIitm">
              {{ $t("label.Acceptance.AcceptanceMaterials") }}
               <Tooltip
                placement="left-start"
                :transfer="true"
                :maxWidth="480"
                :content="$t('label.Acceptance.Tips.Matter') +'\n' +$t('label.Acceptance.Tips.Services')"
              >
                <Icon type="ios-help-circle-outline" />
              </Tooltip>
            </th>
            <td>
               <ab-upload
                v-model="formdata.acceptanceFile"
                abPermission="w"
                 :disabled="permission.TACCEPTANCEAPPLY.acceptanceFile!=='w'"
                 :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"
               ></ab-upload>
            </td>
            <th class="requiredIitm">{{ $t("label.Acceptance.Note") }}</th>
            <td>
              <Form-item prop="note">
                <Input
                  type="text"
                  v-model="formdata.note"
                  :disabled="permission.TACCEPTANCEAPPLY.note!=='w'"
                />
              </Form-item>
            </td>
          </tr>

          <tr>
            <th class="requiredIitm">{{ $t("label.Acceptance.AcceptanceDept") }}</th>
            <td>
              <Form-item
                prop="applyDepartment"
                v-if="permission.TACCEPTANCEAPPLY.applyDepartment==='w'"
              >
                <Select
                  v-model="formdata.applyDepartment"
                  :disabled="permission.TACCEPTANCEAPPLY.applyDepartment!=='w'"
                >
                  <Option
                    v-for="item in this.department"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
              </Form-item>
              <Form-item
                prop="applyDepartment"
                v-if="permission.TACCEPTANCEAPPLY.applyDepartment!=='w'"
              >
                <Input type="text" v-model="formdata.applyDepartmentName" disabled />
              </Form-item>
            </td>
            <th class="requiredIitm">{{ $t("label.Acceptance.AcceptanceDate") }}</th>
            <td>
              <Form-item prop="applyData">
                <ab-date
                  :disabled="permission.TACCEPTANCEAPPLY.applyData!=='w'"
                  style="width:100%;"
                  v-model="formdata.applyData"
                  format="yyyy-MM-dd"
                ></ab-date>
              </Form-item>
            </td>
          </tr>
           <tr>
               <!-- 件名 -->
              <th class="requiredIitm">
                <span>{{ $t("label.Acceptance.caseName") }}</span>
              </th>
              <td colspan="6">
                <Form-item prop="caseName">
                  <Input type="text"
                  :disabled="permission.TACCEPTANCEAPPLY.caseName!=='w'"
                   v-model="formdata.caseName" />
                </Form-item>
              </td>
              </tr>
        </table>
      </Form>
      <!-- 明细表格部分 -->
      <Form ref="listForm" :rules="rule" :model="tableObj" style="margin-top:40px;" class="form-table-th-margin">
        <Table style="margin-top: 15px" border :columns="columns" :data="tableObj.list">
          <!-- 品目 -->
          <template slot-scope="{ row, index }" slot="itemEntrustmentName">
            <FormItem :prop="`list.${index}.itemEntrustmentName`" :rules="rule.itemEntrustmentName">
              <Input type="text" v-model="tableObj.list[index].itemEntrustmentName" disabled />
            </FormItem>
          </template>
          <!-- 供应商名称 -->
          <!-- <template slot-scope="{ row, index }" slot="vendorName">
            <FormItem :prop="`list.${index}.vendorName`" :rules="rule.vendorName">
              <Input type="text" v-model="tableObj.list[index].vendorName" disabled />
            </FormItem>
          </template> -->
          <!-- 验收总金额 -->
          <!-- <template slot-scope="{ row, index }" slot="acceptanceTotAmount">
            <FormItem :prop="`list.${index}.acceptanceTotAmount`" :rules="rule.acceptanceTotAmount">
              <InputNumber
                disabled
                :active-change="false"
                :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="value => value.replace(/\s?|(,*)/g, '')"
                :precision="2"
                style="width:100%;"
                :min="0"
                @on-change="numberchange($event,item.swgysList[row._index],0)"
                v-model="tableObj.list[index].acceptanceTotAmount"
              ></InputNumber>
            </FormItem>
          </template>-->
          <!-- 已验收金额 -->
          <template slot-scope="{ row, index }" slot="acceptanceYAmount">
            <FormItem :prop="`list.${index}.acceptanceYAmount`" :rules="rule.acceptanceYAmount">
              <InputNumber
                disabled
                :active-change="false"
                :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="value => value.replace(/\s?|(,*)/g, '')"
                :precision="2"
                style="width:100%;"
                :min="0"
                @on-change="numberchange($event,item.swgysList[row._index],0)"
                v-model="tableObj.list[index].acceptanceYAmount"
              ></InputNumber>
            </FormItem>
          </template>
          <!-- 未验收金额 -->
          <!-- <template slot-scope="{ row, index }" slot="acceptanceNAmount">
            <FormItem :prop="`list.${index}.acceptanceNAmount`" :rules="rule.acceptanceNAmount">
              <InputNumber
                disabled
                :active-change="false"
                :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="value => value.replace(/\s?|(,*)/g, '')"
                :precision="2"
                style="width:100%;"
                :min="0"
                @on-change="numberchange($event,item.swgysList[row._index],0)"
                v-model="tableObj.list[index].acceptanceNAmount"
              ></InputNumber>
            </FormItem>
          </template>-->
          <!-- 验收中金额 -->
          <template slot-scope="{ row, index }" slot="acceptanceAmountS">
            <FormItem>
              <InputNumber
                disabled
                :active-change="false"
                :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="value => value.replace(/\s?|(,*)/g, '')"
                :precision="2"
                style="width:100%;"
                :min="0"
                @on-change="numberchange($event,item.swgysList[row._index],0)"
                v-model="acceptanceAmountS[index]"
              ></InputNumber>
            </FormItem>
          </template>
          <!-- 验收金额 -->
          <template slot-scope="{ row, index }" slot="acceptanceAmount">
            <FormItem
              :prop="`list.${index}.acceptanceAmount`"
              :rules="[
                {
                  type: 'number',
                  trigger: 'change',
                  validator: (rule, value, callback) => {
                    numberValidator(
                      rule,
                      value,
                      callback,
                      row,
                      acceptanceAmountS[index]
                    );
                  },
                },
              ]"
            >
              <InputNumber
                :disabled="permission.TACCEPTANCEAPPLYDETAIL.acceptanceAmount!=='w'"
                :active-change="false"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\s?|(,*)/g, '')"
                :precision="2"
                style="width: 100%"
                :min="0"
                v-model="tableObj.list[index].acceptanceAmount"
                 :onkeyup="calculatePrice(tableObj.list[index])"
              ></InputNumber>
            </FormItem>
          </template>
          <!-- 备注 -->
          <template slot-scope="{ row, index }" slot="note">
            <FormItem
              :prop="`list.${index}.note`">
              <Input
                type="text"
                v-model="tableObj.list[index].note"
                :disabled="permission.TACCEPTANCEAPPLYDETAIL.note!=='w'"
              />
            </FormItem>
          </template>  
          <!-- <template slot-scope="{ row, index }" slot="note">
            <FormItem
              :prop="`list.${index}.note`"
              :rules="[
                {
                  trigger: 'change',
                  validator: (rule, value, callback) => {
                    noteAcceptanceFile(
                      rule,
                      value,
                      callback,
                      row
                    );
                  },
                },
              ]"
            >
              <Input
                type="text"
                v-model="tableObj.list[index].note"
                :disabled="permission.TACCEPTANCEAPPLYDETAIL.note!=='w'"
              />
            </FormItem>
          </template> -->
          <!-- 验收材料证明 -->
          <!-- <template slot-scope="{ row, index }" slot="acceptanceFile">
            <ab-upload
              v-model="tableObj.list[index].acceptanceFile"
              abPermission="w"
              :disabled="permission.TACCEPTANCEAPPLYDETAIL.acceptanceFile!=='w'"
            ></ab-upload>
          </template> -->


        <!-- 规格 -->
          <template slot-scope="{ row, index }" slot="specifications" >
            <FormItem
              :prop="`list.${index}.specifications`"
               :rules="[{  trigger: 'change', validator:(rule,value,callback)=>{changeSpecifications(rule,index,tableObj.list[index].specifications,callback)}}]">
              <Input
                type="text"
                v-model="tableObj.list[index].specifications"
                 v-bind:disabled="tableObj.list[index].subjectServer==1 || permission.TACCEPTANCEAPPLYDETAIL.specifications !== 'w'"
              />
            </FormItem>
          </template>

          <!-- 期间 -->
          <template slot-scope="{ row, index }" slot="businessHoursEnd">
            <FormItem style="display: inline-block" 
            :prop="`list.${index}.specifications`"
            :rules="[{  trigger: 'change', validator:(rule,value,callback)=>{changeDate(rule,tableObj.list[index].businessHoursStart,tableObj.list[index].businessHoursEnd,index,callback)}}]">
              <ab-date
                style="width: 47%;"
                v-model="tableObj.list[index].businessHoursStart"
                format="yyyy-MM-dd"
                v-bind:disabled="tableObj.list[index].subjectObject==2 || permission.TACCEPTANCEAPPLYDETAIL.businessHoursStart !== 'w'"
              ></ab-date>
              <span>~</span>
              <ab-date
                style="width: 47%;"
                v-model="tableObj.list[index].businessHoursEnd"
                format="yyyy-MM-dd"
                v-bind:disabled="tableObj.list[index].subjectObject==2 || permission.TACCEPTANCEAPPLYDETAIL.businessHoursEnd !== 'w'"
              ></ab-date>
            </FormItem>
            
            <!-- <FormItem :prop="`list.${index}.businessHoursEnd`" :rules="rule.qijian" style="display:inline-block;">
             <ab-date
                style="width: 10%;display:inline;margin:0 0;padding:0 0;"
                v-model="tableObj.list[index].businessHoursEnd"
                format="yyyy-MM-dd"
              ></ab-date>          
            </FormItem> -->
          </template>

          <!-- 纳期 -->
          <template slot-scope="{ row, index }" slot="deliveryDeadline">
            <FormItem :prop="`list.${index}.deliveryDeadline`" :rules="[{  trigger: 'change',  validator:(rule,value,callback)=>{changeDate2(rule,tableObj.list[index].deliveryDeadline,index,callback)}}]">
              <ab-date
                style="width: 100%"
                v-model="tableObj.list[index].deliveryDeadline"
                format="yyyy-MM-dd"
                 v-bind:disabled="tableObj.list[index].subjectServer==1 || permission.TACCEPTANCEAPPLYDETAIL.deliveryDeadline !== 'w'"
              ></ab-date>
            </FormItem>
          </template>

           <!-- 数量 -->
          <template slot-scope="{ row, index }" slot="amount">
            <FormItem :prop="`list.${index}.amount`":rules="[{  trigger: 'change',  validator:(rule,value,callback)=>{changeAmount(rule,tableObj.list[index].amount,index,callback)}}]">
              
              <Input type="tel" v-model="tableObj.list[index].amount"  :onkeyup="calculatePrice(tableObj.list[index])" 
              :disabled="permission.TACCEPTANCEAPPLYDETAIL.amount !== 'w'
              "/>
            </FormItem>
          </template>
          <!-- 单价 -->
          <template slot-scope="{ row, index }" slot="price">
            <FormItem :prop="`list.${index}.price`" >
            <InputNumber
               
                style="width: 100%"
                :min="0"
                v-model="tableObj.list[index].price"
                disabled
              ></InputNumber>
            </FormItem>
          </template>









          <!-- 操作 -->
          <template slot-scope="{ row, index }" slot="remove">
            <FormItem>
              <Button
                type="error"
                @click="remove(index)"
                :disabled="permission.TACCEPTANCEAPPLYDETAIL.acceptanceFile!=='w'"
              >{{ $t("label.Acceptance.Delete") }}</Button>
            </FormItem>
          </template>
        </Table>
      </Form>
      <div
        v-if="tableObj.list[0].vendorId!=='0ZZ' && tableObj.list[0].vendorId!=='0S9' && tableObj.list[0].vendorId!=='0SA' && tableObj.list[0].vendorId!=='0SB' && tableObj.list[0].vendorId!=='0SC'"
      >
        <div class="table_box" style="margin-top: 30px">
          <Form ref="formdatas" :model="formdata" :rules="rules">
            <table
              class="i-iview-table form-table form-table-print form-table-print-sub table_box_content thead_height"
            >
              <!-- <thead>
              <tr class="firstRow" style="height: 35px">
                <th style="width: 200px">{{$t('label.Acceptance.Title01')}}</th>
                <th colspan="4">{{$t('label.Acceptance.Title02')}}</th>
              </tr>
              </thead>-->
              <thead>
                <tr class="firstRow" style="height: 33px">
                  <th
                    style="width: 120px;text-align: center;"
                  >{{$t('label.Acceptance.Content')}}</th>
                  <th style="text-align: center" colspan="3">{{$t('label.Acceptance.Score')}}</th>
                  <th style="width: 200px;text-align: center" >{{$t('Acceptance-004')}}</th>
                </tr>
                <!-- <tr class="firstRow" style="height: 33px">
                  <th style="width: 205px;text-align: center">{{$t('label.Acceptance-Draction01')}}</th>
                  <th style="width: 205px;text-align: center">{{$t('label.Acceptance-Draction02')}}</th>
                  <th style="width: 205px;text-align: center">{{$t('label.Acceptance-Draction03')}}</th>
                </tr> -->
              </thead>
              <tbody class="px14">
                <!-- <tr class="h40">
                <td></td>
                <td colspan="3">{{$t('label.Acceptance.Score')}}</td>
                </tr>-->
                <!-- <tr>
                <td>{{$t('label.Acceptance.Content')}}</td>
                </tr>-->
                <tr>
                  <td>{{$t('label.Acceptance.Quality') + ' :'}}</td>
                  <td>
                    <Form-item prop="quality">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_1"
                        @on-change="selectNumber('20', 'select_1', 'quality')"
                      >{{$t('label.Acceptance.Quality01')}}</Radio>
                    </Form-item>
                  </td>
                  <td>--</td>
                  <td>
                    <Form-item prop="quality">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_2"
                        @on-change="selectNumber('0', 'select_2', 'quality')"
                      >{{$t('label.Acceptance.Quality02')}}</Radio>
                    </Form-item>
                  </td>
                  <!-- 质量备注栏 -->
                  <td>
                    <Form-item prop="qualityNote">
                      <Input
                        type="text"
                        v-model="formdata.qualityNote"
                        :disabled="permission.TACCEPTANCEAPPLY.qualityNote!=='w'"
                      />
                    </Form-item>
                  </td>
                </tr>
                <tr>
                  <td>{{$t('label.Acceptance.Delivery') + ' :'}}</td>
                  <td>
                    <Form-item prop="deliveryPeriod">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_3"
                        @on-change="
                      selectNumber('20', 'select_3', 'deliveryPeriod')
                    "
                      >{{$t('label.Acceptance.Delivery01')}}</Radio>
                    </Form-item>
                  </td>
                  <td>--</td>
                  <td>
                    <Form-item prop="deliveryPeriod">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_4"
                        @on-change="selectNumber('0', 'select_4', 'deliveryPeriod')"
                      >{{$t('label.Acceptance.Delivery02')}}</Radio>
                    </Form-item>
                  </td>
                  <!-- 交货期备注栏 -->
                  <td>
                    <Form-item prop="deliveryNote">
                      <Input
                        type="text"
                        v-model="formdata.deliveryNote"
                        :disabled="permission.TACCEPTANCEAPPLY.deliveryNote!=='w'"
                      />
                    </Form-item>
                  </td>
                </tr>
                <tr>
                  <td>{{$t('label.Acceptance.Service') + ' :'}}</td>
                  <td>
                    <Form-item prop="serviceConsclousness">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_5"
                        @on-change="
                      selectNumber('20', 'select_5', 'serviceConsclousness')
                    "
                      >{{$t('label.Acceptance.Service01')}}</Radio>
                    </Form-item>
                  </td>
                  <td>
                    <Form-item prop="serviceConsclousness">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_6"
                        @on-change="
                      selectNumber('10', 'select_6', 'serviceConsclousness')
                    "
                      >{{$t('label.Acceptance.Service02')}}</Radio>
                    </Form-item>
                  </td>
                  <td>
                    <Form-item prop="serviceConsclousness">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_7"
                        @on-change="
                        selectNumber('0', 'select_7', 'serviceConsclousness')
                      "
                      >{{$t('label.Acceptance.Service03')}}</Radio>
                    </Form-item>
                  </td>
                  <!-- 服务意识备注栏 -->
                  <td>
                    <Form-item prop="serviceNote">
                      <Input
                        type="text"
                        v-model="formdata.serviceNote"
                        :disabled="permission.TACCEPTANCEAPPLY.serviceNote!=='w'"
                      />
                    </Form-item>
                  </td>
                </tr>
                <tr>
                  <td>{{$t('label.Acceptance.Technical') + ' :'}}</td>
                  <td>
                    <Form-item prop="technicalCapability">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_8"
                        @on-change="
                      selectNumber('20', 'select_8', 'technicalCapability')
                    "
                      >{{$t('label.Acceptance.Technical01')}}</Radio>
                    </Form-item>
                  </td>
                  <td>
                    <Form-item prop="technicalCapability">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_9"
                        @on-change="
                      selectNumber('10', 'select_9', 'technicalCapability')
                    "
                      >{{$t('label.Acceptance.Technical02')}}</Radio>
                    </Form-item>
                  </td>
                  <td>
                    <Form-item prop="technicalCapability">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_10"
                        @on-change="
                      selectNumber('0', 'select_10', 'technicalCapability')
                    "
                      >{{$t('label.Acceptance.Technical03')}}</Radio>
                    </Form-item>
                  </td>
                  <!-- 技术能力备注栏 -->
                  <td>
                    <Form-item prop="technologyNote">
                      <Input
                        type="text"
                        v-model="formdata.technologyNote"
                        :disabled="permission.TACCEPTANCEAPPLY.technologyNote!=='w'"
                      />
                    </Form-item>
                  </td>
                </tr>
                <tr>
                  <td>{{$t('label.Acceptance.Management') + ' :'}}</td>
                  <td>
                    <Form-item prop="managementAbility">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_11"
                        @on-change="
                        selectNumber('20', 'select_11', 'managementAbility')
                      "
                      >{{$t('label.Acceptance.Management01')}}</Radio>
                    </Form-item>
                  </td>
                  <td>
                    <Form-item prop="managementAbility">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_12"
                        @on-change="
                        selectNumber('10', 'select_12', 'managementAbility')
                      "
                      >{{$t('label.Acceptance.Management02')}}</Radio>
                    </Form-item>
                  </td>
                  <td>
                    <Form-item prop="managementAbility">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_13"
                        @on-change="
                        selectNumber('0', 'select_13', 'managementAbility')
                      "
                      >{{$t('label.Acceptance.Management03')}}</Radio>
                    </Form-item>
                  </td>
                  <!-- 管理能力备注栏 -->
                  <td>
                    <Form-item prop="AdministrationNote">
                      <Input
                        type="text"
                        v-model="formdata.AdministrationNote"
                        :disabled="permission.TACCEPTANCEAPPLY.AdministrationNote!=='w'"
                      />
                    </Form-item>
                  </td>
                </tr>
              </tbody>
            </table>
            <div style="display:flex;align-items:center;margin-top:20px;">
              <span>{{$t('label.Acceptance.Damage') + ' :'}}</span>
              <div style="display: inline-block; width: 10%">
                <Form-item prop="damageStatus" class="px14">
                  <RadioGroup v-model="formdata.damageStatus" @on-change="damageStatust()">
                    <Radio
                      :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                      label="0"
                    >{{$t('label.Acceptance.Damage02')}}</Radio>
                    <Radio
                      :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                      label="1"
                    >{{$t('label.Acceptance.Damage01')}}</Radio>
                  </RadioGroup>
                </Form-item>
              </div>
              <div v-if="formdata.damageStatus === '1'" style="display: inline-block; width: 60%">
                <Form-item prop="damageStatusNote">
                  <i-input
                    :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                    v-model="formdata.damageStatusNote"
                  >​</i-input>
                </Form-item>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </Card>
  </div>
</template>
<script>
import util from "@/libs/util";
export default {
  data: function() {
    return {
      permission: {},
      damage: false,

      detail: false,

      select_1: false,
      select_2: false,

      select_3: false,
      select_4: false,

      select_5: false,
      select_6: false,
      select_7: false,

      select_8: false,
      select_9: false,
      select_10: false,

      select_11: false,
      select_12: false,
      select_13: false,

      diasabledInput: false,
      department: [],
      acceptanceAmountS: [],
      swsubject:"",
      fwsubject:"",
      tableObj: {
        list: [
          {
            itemEntrustmentName: "",
            vendorName: "",
            //acceptanceTotAmount: "",
            acceptanceYAmount: "",
            //acceptanceNAmount: "",
            itemName: "",
            acceptanceAmount: "",
            note: "",
            acceptanceFile: "",
            amount: "",
            price: "",
            specifications: "",
            businessHoursStaryt: "",
            businessHoursEnd: "",
            deliveryDeadline: "",
            subjectServer:"",
            subjectObject:""
          }
        ]
      },
      rules: {
        // acceptanceId: [
        //   {
        //     required: true,
        //     message: `${$t("label.Acceptance.AcceptanceNo")}不能为空`,
        //     trigger: "change"
        //   }
        // ],
        applicantUserId: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.AcceptanceID"),
            trigger: "change"
          }
        ],
        applicantUserName: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.AcceptorName"),
            trigger: "change"
          }
        ],
        damageStatusNote: [
          {
            required: true,
            message: util.getmsg(this, "ERR.AcceptanceApply.003"),
            trigger: "change"
          }
        ],
        // applyDepartment: [
        //   {
        //     required: true,
        //     message: `${$t("label.Acceptance.AcceptanceDept")}不能为空`,
        //     trigger: "change",
        //   },
        // ],
        applyData: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.AcceptanceDate"),
            trigger: "change"
          }
        ],
        managementAbility: [
          {
            required: true,
            message: $t("label.Acceptance.Title03"),
            trigger: "change"
          }
        ],
        technicalCapability: [
          {
            required: true,
            message: $t("label.Acceptance.Title03"),
            trigger: "change"
          }
        ],
        serviceConsclousness: [
          {
            required: true,
            message: $t("label.Acceptance.Title03"),
            trigger: "change"
          }
        ],
        deliveryPeriod: [
          {
            required: true,
            message: $t("label.Acceptance.Title03"),
            trigger: "change"
          }
        ],
        quality: [
          {
            required: true,
            message: $t("label.Acceptance.Title03"),
            trigger: "change"
          }
        ],
        // qualityNote: [
        //   {
        //     required: true,
        //     message: util.getmsg(this, "Acceptance-004"),
        //     trigger: "change"
        //   }
        // ],
        // deliveryNote: [
        //   {
        //     required: true,
        //     message: util.getmsg(this, "Acceptance-004"),
        //     trigger: "change"
        //   }
        // ],
        // serviceNote: [
        //   {
        //     required: true,
        //     message: util.getmsg(this, "Acceptance-004"),
        //     trigger: "change"
        //   }
        // ],
        // technologyNote: [
        //   {
        //     required: true,
        //     message: util.getmsg(this, "Acceptance-004"),
        //     trigger: "change"
        //   }
        // ],
        // AdministrationNote: [
        //   {
        //     required: true,
        //     message: util.getmsg(this, "Acceptance-004"),
        //     trigger: "change"
        //   }
        // ],
         price: [
          {
            required: true,
            type: "number",
            message: util.getmsg(this, "label.Acceptance.price"),
            trigger: "change",
          },
        ],
        amount: [
          {
             required: true,
            type: "number",
            message: util.getmsg(this, "label.Acceptance.amount"),
            trigger: "change",
            
          },
        ],
        vendorName: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.SupplierName"),
            trigger: "change",
          },
        ],
        caseName: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.caseName"),
            trigger: "change",
          },
        ],
        note: [
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              if (
                !value &&
                (!this.formdata.acceptanceFile || this.formdata.acceptanceFile === "[]") &&
                !this.formdata.note
              ) {
                callback($t("ERR.AcceptanceApply.002"));
              } else {
                callback();
              }
            } 
          },
        ]
      },
      columns: [
        {
          title: `${$t("label.Acceptance.No")}`,
          type: "index",
          width: 50,
          align: "center"
        },
        {
          title: `${$t("label.Acceptance.PhysicalService")}`,
          slot: "itemEntrustmentName",
          align: "center",
          width: 230,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.Acceptance.PhysicalService")
            );
          }
        },
        // {
        //   title: `${$t("label.Acceptance.SupplierName")}`,
        //   slot: "vendorName",
        //   align: "center",
        //   width: 250,
        //   renderHeader: (h, params) => {
        //     return h(
        //       "div",
        //       { class: "requiredIitm" },
        //       $t("label.Acceptance.SupplierName")
        //     );
        //   }
        // },
        // {
        //   title: `${$t("label.Acceptance.Total")}`,
        //   slot: "acceptanceTotAmount",
        //   align: "center",
        //   width: 200,
        //   renderHeader: (h, params) => {
        //     return h("div", { class: "requiredIitm" }, $t("label.Acceptance.Total"));
        //   }
        // },
        {
          title: `${$t("label.Acceptance.AcceptedAmount")}`,
          slot: "acceptanceYAmount",
          align: "center",
          width: 130,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.Acceptance.AcceptedAmount")
            );
          }
        },
        // {
        //   title: `${$t("label.Acceptance.UnacceptedAmount")}`,
        //   slot: "acceptanceNAmount",
        //   align: "center",
        //   width: 200,
        //   renderHeader: (h, params) => {
        //     return h("div", { class: "requiredIitm" }, $t("label.Acceptance.UnacceptedAmount"));
        //   }
        // },
        {
          title: `${$t("label.Acceptance.AmountInAcceptance")}`,
          slot: "acceptanceAmountS",
          align: "center",
          width: 130,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.Acceptance.AmountInAcceptance")
            );
          }
        },
        {
          title: `${$t("label.Acceptance.TotalAmount")}`,
          slot: "acceptanceAmount",
          align: "center",
          width: 130,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.Acceptance.TotalAmount")
            );
          }
        },
        //数量
        {
          title: `${$t("label.Acceptance.amount")}`,
          slot: "amount",
          align: "center",
          width: 120,
          renderHeader: (h, params) => {
            return h("div", { class: "requiredIitm" }, $t("label.Acceptance.amount"));
          },
        },
        //单价
        {
          title: `${$t("label.Acceptance.price")}`,
          slot: "price",
          align: "center",
          width: 130,
          renderHeader: (h, params) => {
            return h("div", { }, $t("label.Acceptance.price"));
          },
        },
        //规格
        {
          title: `${$t("label.Acceptance.specification")}`,
          slot: "specifications",
          align: "center",
          width: 230,
          renderHeader: (h, params) => {
            return h("div", {  }, $t("label.Acceptance.specification")+$t("label.Acceptance.server"));
          },
        },
        //纳期
        {
           title: `${$t("label.Acceptance.deliveryDeadline")}`,
          slot: "deliveryDeadline",
          align: "center",
          width: 130,
          renderHeader: (h, params) => {
            return h("div", { class: "requiredIitm" }, $t("label.Acceptance.deliveryDeadline")+$t("label.Acceptance.server"));
          },
        },
        //期间
        {
          title: `${$t("label.Acceptance.period")}`,
          slot: "businessHoursEnd",
          align: "center",
          width: 330,
          renderHeader: (h, params) => {
            return h("div", { class: "requiredIitm" }, $t("label.Acceptance.period")+$t("label.Acceptance.object"));
          },
        },
        {
          title: `${$t("label.AcceptanceApplyDetail.Note")}`,
          slot: "note",
          align: "center",
          width: 230
        },
        //         <Tooltip
        //   style="width:100%;margin-top:5px;"
        //   max-width="400"
        //   :disabled="item.swgysList[row._index].vendorName===''"
        //   :content="item.swgysList[row._index].vendorName"
        //   :transfer="true"
        // >
        // {
        //   title: `${$t("label.Acceptance.AcceptanceMaterials")}`,
        //   slot: "acceptanceFile",
        //   renderHeader: (h, params) => {
        //     return h("div", [
        //       h(
        //         "Tooltip",
        //         {
        //           props: {
        //             placement: "left-start",
        //             maxWidth: 800,
        //             transfer: true,
        //             content:
        //               $t("label.Acceptance.Tips.Matter") +
        //               "\n" +
        //               $t("label.Acceptance.Tips.Services")
        //           }
        //         },
        //         [
        //           $t("label.Acceptance.AcceptanceMaterials"),
        //           h("Icon", {
        //             props: {
        //               type: "ios-help-circle-outline"
        //             },
        //             style: {
        //               fontSize: "18px", // 改变icon的样式
        //               color: "#fff"
        //             }
        //           })
        //         ]
        //       )
        //       // h("Icon", {
        //       //   props: {
        //       //     type: "ios-help-circle-outline"
        //       //   },
        //       //   style: {
        //       //     fontSize: "18px", // 改变icon的样式
        //       //     color: "#fff",
        //       //     marginLeft:'5px'
        //       //   }
        //       // })
        //     ]);
        //   },
        //   align: "center",
        //   width: 200
        // },
        {
          title: `${$t("label.Acceptance.Operation")}`,
          slot: "remove",
          align: "center",
          width: 80
        }
      ],
      rule: {
        itemEntrustmentName: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.PhysicalService"),
            trigger: "change"
          }
        ],
        vendorName: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.SupplierName"),
            trigger: "change"
          }
        ],
        // acceptanceTotAmount: [
        //   {
        //     required: true,
        //     type: "number",
        //     message: util.getmsg(this,'label.Acceptance.Total'),
        //     trigger: "change"
        //   }
        // ],
        itemName: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.AmountInAcceptance"),
            trigger: "change"
          }
        ],
        acceptanceAmount: [
          {
            required: true,
            type: "number",
            message: util.getmsg(this, "label.Acceptance.TotalAmount"),
            trigger: "change"
          }
        ],
        price: [
          {
            required: true,
            type: "number",
            message: util.getmsg(this, "label.Acceptance.price"),
            trigger: "change",
          },
        ],
        
        deliveryDeadLine:[
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.deliveryDeadline"),
            trigger: "change",
            
          }
        ],
        amount:[
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.amount"),
            trigger: "change",
            
          }
        ],
        caseName:[
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.caseName"),
            trigger: "change",
            
          }
        ],
       
      }
    };
  },
  props: {
    formdata: {
      //默认数据
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.permission = this.$parent.permission.AcceptanceApplication;
    this.formdata.vendorName = this.formdata.TACCEPTANCEAPPLYDETAILList[0].vendorName;
    this.getDepartment(),
      (this.tableObj.list = this.formdata.TACCEPTANCEAPPLYDETAILList);
    this.getAcceptanceAmount();
    this.detail = !this.$parent.instance
      ? false
      : this.$parent.instance.status === "end" ||
        this.$parent.instance.status === "running"
      ? true
      : this.$parent.instance.status === "draft"
      ? false
      : false ||
        this.$parent.flowRequestParam.extendConf ||
        this.$parent.flowRequestParam.extendConf.nodeId
      ? true
      : false;
    if (this.formdata.flowStatus == null) {
      if (this.detail == false) {
        for (var i = 0; i < this.tableObj.list.length; i++) {
          this.tableObj.list[i].acceptanceAmount = "";
          this.tableObj.list[i].price="";
           if(this.tableObj.list[i].deliveryDeadline==null||this.tableObj.list[i].deliveryDeadline==""){
             if(this.tableObj.list[i].vendorId=='0S9'||this.tableObj.list[i].vendorId=='0SA'||this.tableObj.list[i].vendorId=='0SB'||this.tableObj.list[i].vendorId=='0SC'||this.tableObj.list[i].vendorId=='0ZZ'){
              this.tableObj.list[i].subjectServer="0"
            }else{
                  this.tableObj.list[i].subjectServer="1"
            }   
          }else{
            this.tableObj.list[i].subject="0"
          }
          if(this.tableObj.list[i].businessHoursStart==null||this.tableObj.list[i].businessHoursStart==""){
            if(this.tableObj.list[i].vendorId=='0S9'||this.tableObj.list[i].vendorId=='0SA'||this.tableObj.list[i].vendorId=='0SB'||this.tableObj.list[i].vendorId=='0SC' ||this.tableObj.list[i].vendorId=='0ZZ'){
                this.tableObj.list[i].subjectObject="2"
            }else{
            this.tableObj.list[i].subjectObject="2"
            }
              
          }else{
            this.tableObj.list[i].subject="0"
          }
        }
      }
    }

    //初始化一次评分
    if (!this.formdata.quality) {
      this.$set(this.formdata, "quality", "");
    }
    if (!this.formdata.deliveryPeriod) {
      this.$set(this.formdata, "deliveryPeriod", "");
    }
    if (!this.formdata.serviceConsclousness) {
      this.$set(this.formdata, "serviceConsclousness", "");
    }
    if (!this.formdata.technicalCapability) {
      this.$set(this.formdata, "technicalCapability", "");
    }
    if (!this.formdata.managementAbility) {
      this.$set(this.formdata, "managementAbility", "");
    }
    if (!this.formdata.totalScore) {
      this.$set(this.formdata, "totalScore", "0");
    }
    if (!this.formdata.applyData) {
      this.$set(
        this.formdata,
        "applyData",
        this.moment(new Date()).format("YYYY-MM-DD")
      );
    }
    if (!this.formdata.damageStatus) {
      this.$set(this.formdata, "damageStatus", "0");
    }

    // 详情禁用 赋值

    this.select_1 = this.formdata.quality === "20" ? true : false;
    this.select_2 = this.formdata.quality === "0" ? true : false;

    this.select_3 = this.formdata.deliveryPeriod === "20" ? true : false;
    this.select_4 = this.formdata.deliveryPeriod === "0" ? true : false;

    this.select_5 = this.formdata.serviceConsclousness === "20" ? true : false;
    this.select_6 = this.formdata.serviceConsclousness === "10" ? true : false;
    this.select_7 = this.formdata.serviceConsclousness === "0" ? true : false;

    this.select_8 = this.formdata.technicalCapability === "20" ? true : false;
    this.select_9 = this.formdata.technicalCapability === "10" ? true : false;
    this.select_10 = this.formdata.technicalCapability === "0" ? true : false;

    this.select_11 = this.formdata.managementAbility === "20" ? true : false;
    this.select_12 = this.formdata.managementAbility === "10" ? true : false;
    this.select_13 = this.formdata.managementAbility === "0" ? true : false;
  },
  methods: {

    //数量校验
    changeAmount(rule,value,index,callback){
      if(!value){
          callback(util.getmsg(this, "label.Acceptance.amount"));
        }else{
           callback();
        }
    },

 //规格校验
    changeSpecifications(rule,index,value,callback){
        if(this.tableObj.list[index].subjectServer==1){
          callback();
        }else{
          callback();
        //  if(!value){
        //   callback(util.getmsg(this, "label.Acceptance.specification"));
        // }else{
        //    callback();
        // }
        }
    },

    //计算单价
     calculatePrice(value){
      
          var z=value.acceptanceAmount/value.amount

          //保留2为小数
          var f = Math.round(z*100)/100;  
          var s = f.toString();       
          var rs = s.indexOf('.');      
          if (rs < 0) {   
          rs = s.length;      
           s += '.';   
            }       
            while (s.length <= rs + 2) {   
 s += '0';       
          }
          if(value.amount=="" || value.acceptanceAmount=="" || value.amount==null){
            value.price=""
          }else{
            if(!isNaN(value.amount)){
                value.price=s
            }else{
              value.price=""
              value.amount=""
            }
          
          }
          
        
     },
   

      //纳期校验
    changeDate2(rule,value,index,callback){
       if(this.tableObj.list[index].subjectServer==1){
          callback();
        }else{
          if(!value){
          callback(util.getmsg(this, "label.Acceptance.deliveryDeadline"));
        }else{
           callback();
        }
        }
    },
    //表单提交
    // formdata
    // formDynamic
    // formService
    async handleSubmit() {
      let validateflg = false;
      let flg = 0;
      let jie = 2;
      this.$refs.formdata.validate(valid => {
        if (valid) {
          flg++;
        }
      });
      await this.$refs.listForm.validate(valid => {
        if (valid) {
          flg++;
        }
      });
      if(this.tableObj.list[0].vendorId!=='0ZZ' && this.tableObj.list[0].vendorId!=='0S9' && this.tableObj.list[0].vendorId!=='0SA' && this.tableObj.list[0].vendorId!=='0SB' && this.tableObj.list[0].vendorId!=='0SC'){
       jie++;
       await this.$refs.formdatas.validate(valid => {
          if (valid) {
            flg++;
          }
        });
      }
      if (flg === jie) {
        if (this.tableObj.list.length > 0) {
          this.$parent.data.AcceptanceApplication.TACCEPTANCEAPPLYDETAILList = this.tableObj.list;
          var ids = new Array();
          for (var i = 0; i < this.tableObj.list.length; i++) {
            ids.push(
              this.formdata.TACCEPTANCEAPPLYDETAILList[i].verdictId +
                this.formdata.TACCEPTANCEAPPLYDETAILList[i].inquiryDetailId
            );
          }
          await this.abHttpUtil
            .post("/acceptanceSearch/getVerdictStatus?ids=" + ids, {})
            .then(res => {
              if (res == 0) {
                validateflg = true;
              } else {
                this.$Message.error($t("ERR.AcceptanceSearch.003"));
              }
            });
        } else {
          this.$Message.error($t("ERR.AcceptanceApply.004"));
        }
      } else {
        this.errmsg();
      }
      return validateflg;
    },
    //期间校验(判断是否为空,判断期间开始时间与期间结束时间大小)
   changeDate(rule,value1,value2,index,callback){
      if(this.tableObj.list[index].subjectObject==2){
        callback();
      } else{
      var start = this.moment(value1)
        .format("YYYY-MM-DD")
        .replace(/-/g, "");
      var end = this.moment(value2)
        ? this.moment(value2)
            .format("YYYY-MM-DD")
            .replace(/-/g, "")
        : 999999999999999;
      if (!value1||!value2) {
        callback(util.getmsg(this, "label.Acceptance.period"));
      } else if (start > end) {
        callback($t("ERR.AcceptanceApply.005"));
      } else {
        callback();
      }
      }
        
    },
    //表格删除列
    remove(index) {
      if (this.tableObj.list.length > 1) {
        this.tableObj.list.splice(index, 1);
      }
    },
    //公用校验
    errmsg() {
      this.$nextTick(() => {
        var errMsg = [];
        var errList = document.querySelectorAll(".ivu-form-item-error-tip");
        errList.forEach(val => {
          if (errMsg.indexOf(val.innerHTML) == -1) {
            errMsg.push(val.innerHTML);
          }
        });
        errMsg.forEach(val => {
          this.$Message.error(val);
        });
      });
    },
    getDepartment() {
      this.abHttpUtil.post("/common/department", {}).then(res => {
        const data = res;
        data.forEach(item => {
          this.department.push(item);
        });
        if (this.formdata.applyDepartment == null) {
          if (this.department[0].id !== null) {
            this.formdata.applyDepartment = this.department[0].id;
          }
        }
      });
    },
    selectNumber(e, type, key) {
      this.$set(this.formdata, key, e);
      if (type === "select_1") {
        this.select_2 = false;
      }
      if (type === "select_2") {
        this.select_1 = false;
      }

      if (type === "select_3") {
        this.select_4 = false;
      }
      if (type === "select_4") {
        this.select_3 = false;
      }

      if (type === "select_5") {
        this.select_6 = false;
        this.select_7 = false;
      }
      if (type === "select_6") {
        this.select_5 = false;
        this.select_7 = false;
      }
      if (type === "select_7") {
        this.select_5 = false;
        this.select_6 = false;
      }

      if (type === "select_8") {
        this.select_9 = false;
        this.select_10 = false;
      }
      if (type === "select_9") {
        this.select_8 = false;
        this.select_10 = false;
      }
      if (type === "select_10") {
        this.select_8 = false;
        this.select_9 = false;
      }

      if (type === "select_11") {
        this.select_12 = false;
        this.select_13 = false;
      }
      if (type === "select_12") {
        this.select_11 = false;
        this.select_13 = false;
      }
      if (type === "select_13") {
        this.select_11 = false;
        this.select_12 = false;
      }

      var count =
        parseInt(this.formdata.quality === "" ? 0 : this.formdata.quality) +
        parseInt(
          this.formdata.deliveryPeriod === "" ? 0 : this.formdata.deliveryPeriod
        ) +
        parseInt(
          this.formdata.serviceConsclousness === ""
            ? 0
            : this.formdata.serviceConsclousness
        ) +
        parseInt(
          this.formdata.technicalCapability === ""
            ? 0
            : this.formdata.technicalCapability
        ) +
        parseInt(
          this.formdata.managementAbility === ""
            ? 0
            : this.formdata.managementAbility
        );
      this.$set(this.formdata, "totalScore", count.toString());
    },
    async numberValidator(rule, value, callback, row, number) {
      // await this.abHttpUtil
      //   .post(
      //     "/acceptanceApply/acceptanceInquiryDetailId?inquiryDetailId=" +
      //       row.inquiryDetailId +
      //       "&verdictId=" +
      //       row.verdictId,
      //     {}
      //   )
      //   .then(res => {
      //     if(res.rows[0].acceptanceNAmount!==null){
      //         row.acceptanceNAmount = res.rows[0].acceptanceNAmount;
      //     }
      //   });
      if (!value) {
        callback(util.getmsg(this, "label.Acceptance.TotalAmount"));
        // } else if (value > row.acceptanceNAmount) {
        //   callback($t("ERR.AcceptanceApply.001"));
      } else {
        callback();
      }
    },
    // noteAcceptanceFile(value, callback) {
    //   if (
    //     !value &&
    //     (!this.formdata.acceptanceFile || this.formdata.acceptanceFile === "[]") &&
    //     !this.formdata.note
    //   ) {
    //     callback($t("ERR.AcceptanceApply.002"));
    //   } else {
    //     callback();
    //   }
    // },
    damageStatust() {
      if (this.formdata.damageStatus === "1") {
        this.damage = true;
      } else {
        this.damage = false;
        this.formdata.damageStatusNote = "";
      }
    },
    async getAcceptanceAmount() {
      for (var i = 0; i < this.tableObj.list.length; i++) {
        if (
          this.formdata.flowStatus == "2" ||
          this.formdata.flowStatus == "3"
        ) {
          await this.abHttpUtil
            .post(
              "/acceptanceApply/acceptanceInquiryDetailId?inquiryDetailId=" +
                this.formdata.TACCEPTANCEAPPLYDETAILList[i].inquiryDetailId +
                "&verdictId=" +
                this.formdata.TACCEPTANCEAPPLYDETAILList[i].verdictId,
              {}
            )
            .then(res => {
              if (res.rows[0].acceptanceAmount !== null) {
                this.$set(
                  this.acceptanceAmountS,
                  [i],
                  res.rows[0].acceptanceAmount
                );
              }
              if (res.rows[0].acceptanceNAmount !== null) {
                this.tableObj.list[i].acceptanceNAmount =
                  res.rows[0].acceptanceNAmount;
              }
              if (res.rows[0].acceptanceYAmount !== null) {
                this.tableObj.list[i].acceptanceYAmount =
                  res.rows[0].acceptanceYAmount;
              }
            });
        } else {
          this.acceptanceAmountS[i] = this.tableObj.list[i].acceptanceAmount;
        }
      }
    }
  }
};
</script>
<style scoped>
body .form-table tr {
  height: 40px;
}
/* body .table_box .form-table.form-table-print th,
.form-table.form-table-print td {
  text-align: left;
} */
body .thead_height th {
  padding: 0px 10px !important;
}
</style>
